<template>
  <div id="stockInfo" class="q-pa-md">
    <q-form id="queryForm" :model="queryForm" @submit="query" @reset="reset">
      <div class="row q-col-gutter-md justify-center">
        <div class="col-12 corner">
          <q-btn color="primary" @click="addStock" label="创建库存" icon="inventory" />
        </div>
        <div class="col-md-3 col-11">
          <q-select outlined v-model="queryForm.customerNo" :options="customerList" option-label="customerName"
            option-value="customerNo" emit-value map-options label="客户名称" dense clearable />
        </div>
        <div class="col-md-3 col-11">
          <q-select outlined v-model="queryForm.yarnType" :options="yarnList" option-label="typeName" option-value="id"
            emit-value map-options label="纱支类型" dense clearable />
        </div>
        <div class="col-11 col-md-3">
          <q-select v-model="queryForm.stockType" label="库存类型" dense clearable outlined emit-value map-options :options="[
            { value: '0', label: '胚纱' },
            { value: '1', label: '色纱' },
          ]">
            <template v-slot:prepend>
              <q-icon name="date_range" />
            </template>
          </q-select>
        </div>
        <div class="col-11 col-md-3">
          <q-select v-model="queryForm.windType" label="成型状态" dense clearable outlined emit-value map-options :options="[
            { value: '0', label: '筒纱' },
            { value: '1', label: '绞纱' },
          ]">
            <template v-slot:prepend>
              <q-icon name="date_range" />
            </template>
          </q-select>
        </div>
        <div class="col-md-3 col-11">
          <q-btn label="查询" type="submit" color="primary" />
          <q-btn label="重置" type="reset" color="primary" flat class="q-ml-sm" />
        </div>
      </div>
    </q-form>

    <q-table ref="mytable" title="库存信息" :data="tableData.list" :columns="columns" row-key="id"
      :pagination.sync="pagination" :loading="loading" @request="request" binary-state-sort separator="cell"
      :rows-per-page-options="[10, 20, 50, 0]">
      <template v-slot:body-cell-opt="props">
        <q-td>
          <div class="q-px-md q-gutter-sm" style="text-align: center">
            <q-btn round color="primary" size="xs" icon="edit" @click="detail(props.index, props.row)" />
            <q-btn round color="deep-orange" size="xs" icon="delete_forever" @click="remove(props.index, props.row)" />
          </div>
        </q-td>
      </template>
      <template v-slot:bottom-row>
        <q-tr v-if="tableData.sumMap">
          <q-td align="center"> 合计 </q-td>
          <q-td align="center"> N/A </q-td>
          <q-td align="center"> N/A </q-td>
          <q-td align="center"> N/A </q-td>
          <q-td align="center"> N/A </q-td>
          <q-td align="center">
            {{
              numbro(tableData.sumMap.SUM_STOCK).format({
                thousandSeparated: true,
                mantissa: 2,
              })
            }}
          </q-td>
          <q-td align="center"> N/A </q-td>
          <q-td align="center"> N/A </q-td>
          <q-td> </q-td>
        </q-tr>
      </template>
    </q-table>
  </div>
</template>

<script>
import { listAll } from "@/api/erp/customer";
import { list as listYarn } from "@/api/erp/yarn";
import { remove, list } from "@/api/erp/stock";
import numbro from "numbro";
export default {
  components: {},
  data() {
    return {
      numbro,
      queryForm: {},
      tableData: {},
      customerList: [],
      yarnList: [],
      loading: false,
      pagination: {
        sortBy: null,
        descending: false,
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 10,
      },
      columns: [
        {
          name: "customerName",
          align: "center",
          label: "客户名称",
          field: (row) => row.customerShortName,
        },
        {
          name: "stockName",
          align: "center",
          label: "库存名称",
          field: "stockName",
        },
        {
          name: "yarnTypeName",
          align: "center",
          label: "纱支类型",
          field: "yarnTypeName",
        },
        {
          name: "stockType",
          align: "center",
          label: "库存类型",
          field: (row) => (row.stockType == "0" ? "胚纱" : "色纱"),
        },
        {
          name: "windType",
          align: "center",
          label: "成型状态",
          field: (row) => {
            let formatter = "";
            if ("0" == row.windType) {
              formatter = "筒纱";
            } else if ("1" == row.windType) {
              formatter = "绞纱";
            }
            return formatter;
          },
        },
        {
          name: "STOCK_QUANTITY",
          align: "center",
          label: "库存数量(kg)",
          field: (row) =>
            numbro(row.stockQuantity || 0).format({
              thousandSeparated: true,
              mantissa: 2,
            }),
          sortable: true,
        },
        {
          name: "location",
          align: "center",
          label: "位置",
          field: "location",
        },
        {
          name: "remark",
          align: "center",
          label: "备注",
          field: "remark",
        },
        {
          name: "opt",
          align: "center",
          label: "操作",
          field: "opt",
        },
      ],
    };
  },
  methods: {
    addStock() {
      this.$router.push("/stock/add");
    },
    detail(index, row) {
      this.$router.push("/stock/details/" + row.id);
    },
    remove(index, row) {
      var self = this;
      this.$q
        .dialog({
          title: "请谨慎操作",
          message: "此操作将永久删除该条记录, 是否继续?",
          cancel: "取消",
          ok: "确定",
          persistent: true,
        })
        .onOk(() => {
          console.log(">>>> OK");
          remove(row.id).then(function () {
            self.$q.notify({ type: "positive", message: "删除成功" });
            self.query();
          });
        })
        .onCancel(() => {
          self.$q.notify({ type: "info", message: "已取消删除" });
        })
        .onDismiss(() => {
          console.log("I am triggered on both OK and Cancel");
        });
    },
    listCustomer() {
      var self = this;
      listAll().then((response) => {
        self.customerList = response.data.data;
      });
    },
    listYarn() {
      var self = this;
      listYarn().then((response) => {
        self.yarnList = response.data.data;
      });
    },
    query() {
      this.$refs.mytable.requestServerInteraction();
    },
    reset() {
      this.queryForm = {};
      this.pagination = {
        sortBy: null,
        descending: false,
        page: 1,
        rowsPerPage: 10,
        rowsNumber: 10,
      };
      this.query();
    },
    request(props) {
      this.loading = true;
      const { page, rowsPerPage, sortBy, descending } = props.pagination;
      var self = this;
      self.queryForm.pageNum = page;
      self.queryForm.pageSize = rowsPerPage;
      if (sortBy) {
        self.queryForm.orderBy = sortBy + (descending ? " desc" : " asc");
      } else {
        self.queryForm.orderBy = null;
      }
      list(self.queryForm).then(function (response) {
        self.tableData = response.data.data;
        self.pagination.rowsNumber = self.tableData.total;
        // don't forget to update local pagination object
        self.pagination.page = page;
        self.pagination.rowsPerPage = rowsPerPage;
        self.pagination.sortBy = sortBy;
        self.pagination.descending = descending;
        // ...and turn of loading indicator
        self.loading = false;
      });
    },
  },
  mounted: function () {
    this.listCustomer();
    this.listYarn();
    this.query();
  },
};
</script>

<style scoped>
.corner {
  flex-direction: row-reverse;
  display: flex;
}

#queryForm {
  /* margin-top: 20px; */
  margin-bottom: 20px;
}
</style>